<template>
    <Page v-if="isUserInGroup('bill')" type="gray" :header="header[lang].title">
        <template v-slot:body>
            <List  />
        </template>
    </Page>
    <Page v-else type="gray">
        <template v-slot:body>
            <Be />
        </template>
    </Page>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import Page from            '@/components/sides/Page.vue' 
import Be from              '@/components/personal/bill/Be.vue'
import List from            '@/views/personal/bill/List.vue'
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            header: {
                en: {title: "My bills"} ,
                ru: {title: "Мои счета"} ,
            }, 
        }
    },
    components: {
        Page,
        Be,
        List
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screen_size() { return this.$store.getters.StateScreenSize },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    methods: {
        ...mapActions(['UpdateHeader']),
        updateHeader() {
            this.UpdateHeader({
                title: this.header[this.lang].title,
                backButton: true,
                backButtonUrl: '/personal/products/',
                profileButton: false
            });
        },
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)}
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.updateHeader()
        this.helper.SetTgAppBackButton(false)
    }
}
</script>